module.exports = __webpack_public_path__ + "img/vipevent_share_icon@2x.8b1ee290.png";